$(function () {

    var language = $('html').attr('lang');
    var lang = '';
    if(language !== 'en'){
        lang = "/" + language;
    }

    // Add Video into playlist
    $('.playlist-widget-add-video').on('click', function() {
        var playlistId = $('#playlist-widget-select').val();
        if(!playlistId) {
            app.notify.info('Please, select playlist');
            return false;
        } else {
            var videoId = $('.playlist-widget-add-video').data('item');
            var url = '/playlist/' + playlistId + '/add-item';
            $.ajax({
                url: url,
                type: 'POST',
                data: {item: videoId},
                dataType: 'json',
                success: function (data) {
                    if (data.ok === true) {
                        app.notify.success("Item added to your playlist");
                    } else {
                        app.notify.error("Error");
                    }
                },
                error: function () {
                    app.notify.error("Server error");
                }
            });
        }
    });

    // Click Create New Playlist! button
    $(document).on('click', '.playlist-widget-create-playlist', function(){
        $('.playlist-widget-create-form').toggle('slow');
    });

    // New playlist create request
    $(document).on('click', '.create-playlist-button', function(){
        var input = $('.playlist-widget-create-form').find('#playlist-name');
        var playlistName = input.val();
        if(!playlistName){
            app.notify.info('Please, enter playlist name');
        } else {
            $('.playlist-widget-create-form').hide();
            var url = '/playlist/create';
            $.ajax({
                url: url,
                type: 'POST',
                data: {name: playlistName},
                dataType: 'json',
                success: function(data){
                    if(data.status === 'success') {
                        console.log(data);
                        app.notify.success("Playlist created");
                        if(data.id){
                            $('#playlist-widget-select')
                                .append($("<option></option>")
                                    .attr("value",data.id)
                                    .text(playlistName));
                            $("#playlist-widget-select").val(data.id).change();
                        }
                    } else {
                        app.notify.error("Error");
                    }
                },
                error: function(){
                    app.notify.error("Server error");
                }
            });
        }
    });
});